import { rise, set } from 'solar-calculator'
import moment from '../lib/moment'

export default function(date, lat, lng) {

  // The solar-calculator library disregards the local UTC offset. (Not entirely
  // sure if that's an oversight or intentional...). So we have to convert the
  // date to UTC while preserving the local date and time.
  const calibratedDate = moment.utc(moment(date).toArray())

  const sunrise = moment(rise(calibratedDate, lat, lng))
  const sunset  = moment(set(calibratedDate, lat, lng))

  return [
    {
      id: `sunrise-${sunrise.valueOf()}`,
      type: 'sunrise',
      moment: sunrise,
    },
    {
      id: `sunset-${sunset.valueOf()}`,
      type: 'sunset',
      moment: sunset,
    },
  ]
}



// WEBPACK FOOTER //
// ./src/services/solar-api.js